// extracted by mini-css-extract-plugin
module.exports =  {"mortgage-offer-card-banner-wrapper":"a10a3f92e9--mortgage-offer-card-banner-wrapper--vkpnv"};